import { create } from "zustand";

/**
 * Semaine et jour affiches par le planning. Hors du composant : ouvrir une
 * reservation puis revenir doit retrouver la meme semaine.
 */
type ScheduleState = {
  /** Lundi affiche, "yyyy-MM-dd" ; null = la semaine en cours. */
  week: string | null;
  day: string | null;
  setWeek: (week: string | null) => void;
  setDay: (day: string) => void;
};

export const useScheduleStore = create<ScheduleState>((set) => ({
  week: null,
  day: null,
  setWeek: (week) => set({ week, day: null }),
  setDay: (day) => set({ day }),
}));
